import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger'
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const locoScroll = new LocomotiveScroll({
  el: document.querySelector('#wrapper'),
  smooth: true,
  lerp: 0.03, // Linear Interpolation, 0 > 1 // Try 0.01
  multiplier: 1.4, // Effect Multiplier
  reloadOnContextChange: true,
  touchMultiplier: 2,
  smoothMobile: 0,
});

locoScroll.on("scroll", ScrollTrigger.update);

// tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
ScrollTrigger.scrollerProxy("#wrapper", {
  scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
  }, // we don't have to define a scrollLeft because we're only scrolling vertically.
  getBoundingClientRect() {
    return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
  },
  // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
  pinType: document.querySelector("#wrapper").style.transform ? "transform" : "fixed"
});


// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

// after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
ScrollTrigger.refresh();

const  height = window.innerHeight;
let isMobile = false;
if( jQuery(window).width() < 768){
  isMobile = true
}



function intro(){

  const tl = gsap.timeline();


  tl.to('.intro__logo',{
    opacity: 0 ,
    scale: 20,
    duration: 1,
    delay: 2,
    ease: "power3.easeIn",
  },'start')

  .to('.intro',{
    opacity: 0 ,
    ease: "power1.easeOut",
  },'+=0.5')
 
  .to('#wrapper',{
    opacity: 1 ,
    ease: "power1.easeOut",
  },'+=0.5')

  .call(()=>{document.querySelector('.intro').remove()})

  return tl;

}

function video1(){

  let scroll = 1300;
  if(isMobile){
    scroll = 600;
  }
 
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.video-banner--1',
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });

  if(isMobile){

    tl.to('.banner-no-1',{
      clipPath:  'circle(90vh at 80vw 50vh)'
    });

  }else{
    tl.to('.banner-no-1',{
      clipPath:  'circle(90vw at 80vw 50vh)'
    });
    
    tl.to('.video-banner--1 .video-banner__info',{
      opacity: 0, 
      delay: .5,
      ease: "power1.easeIn",
    },"-=1.01");

    tl.to('.banner-no-1',{
      scale: .9
    }, "+=0.2")
  
  }
 
 

  return tl;
}

function video2(){

  let scroll = 1000;
  if(isMobile){
    scroll = 600;
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.video-banner--2',
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
  });

  if(isMobile){
    tl.to('img.banner-no-2',{
      maskSize:  '500vw'
    });
  }else{
    tl.to('.video.banner-no-2',{
      maskSize:  '500vw'
    });
    tl.to('.video-banner--2 .video-banner__info',{
      opacity: 0, 
      ease: "power1.easeIn",
    },"+=0.5");
  
    tl.to('.video-banner--2 .video',{
      scale: .9
    }, "+=0.2")
  
  }
  


 

  return tl;
}

function video3(){

  let scroll = height * 7;
  if(isMobile){
    scroll = height * 8;
  }
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.banner3-container .video',
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
  });

  tl.to('.banner3-container .video',{
    maskSize:  '600vw'
  });




  return tl;
}

function video3Info(){
  var tl = "";
  gsap.utils.toArray(".banner3__slice").forEach(box => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: box,
        scroller: '#wrapper',
        start: "top 10%",
        scrub: 1,
      }
    });
    
    tl.to(box,{
      opacity: 0,
      delay: 0.1,
      ease: "power4.easeIn",
    });
 
  });
  tl.to('.banner3-container .video',{
    scale: .9
  }, "-=0.1")
  return tl;

}

function video4(){
  let scroll = 1500;
  if(isMobile){
    scroll = 600;
  }
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.video-banner--4',
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });

  if(isMobile){
    tl.to('.banner-no-4',{
      clipPath:  'circle(100vh at 80vw 50vh)'
    });
  }else{
    tl.to('.banner-no-4',{
      clipPath:  'circle(90vw at 80vw 50vh)'
    });
    tl.to('.video-banner--4 .video-banner__info',{
      opacity: 0, 
      delay: .5,
      ease: "power1.easeIn",
    },"-=1.01");
  
    tl.to('.video-banner--4 .video',{
      scale: .9
    }, "+=0.2")
  }

  

  return tl;
}

function video5(){

  let scroll = height;
  let selector = '.video.banner-no-5';
  if(isMobile){
    selector = 'img.banner-no-5';
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: selector,
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });

  

  tl.to(selector,{
    maskSize:  '600vw'
  });

  return tl;
}
function video5Info(){
  var tl = "";

  gsap.utils.toArray(".banner5__info").forEach(box => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: box,
        scroller: '#wrapper',
        start: "top 10%",
        scrub: 1,
      }
    });
    
    tl.to(box,{
      opacity: 0,
      delay: 0.1,
      ease: "power4.easeOut",
    });
  
  });

  tl.to('.banner3-container .video',{
    scale: .9
  }, "-=0.1")

  return tl;

}

function video6(){

  let scroll = height * 3

  let selector = '.video.banner-no-6';
  if(isMobile){
    selector = 'img.banner-no-6';
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: selector,
      scroller: '#wrapper',
      start: "top: 0",
      end: '+='+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });


  tl.to(selector,{
    maskSize:  '600vw'
  });


  return tl;
}

function video6Info(){
  var tl = "";

  gsap.utils.toArray(".banner6__info").forEach(box => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: box,
        scroller: '#wrapper',
        start: "top 10%",
        scrub: 1,
      }
    });
    
    tl.to(box,{
      opacity: 0,
      delay: 0.1,
      ease: "power4.easeOut",
    });
  
  });

  if(!isMobile){
    tl.to('.video-banner6 .video',{
      scale: .9
    }, "-=0.1")
  }

  return tl;
}

function video7(){

  let scroll = 1500;
  if(isMobile){
    scroll = 600;
  }
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.video-banner--7',
      scroller: '#wrapper',
      start: "top: 0",
      end: "+="+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });

  if(isMobile){
    tl.to('img.banner-no-7',{
      clipPath:  'circle(100vh at 80vw 50vh)'
    });
  }else{
    tl.to('.video.banner-no-7',{
      clipPath:  'circle(90vw at 80vw 50vh)'
    });
  
    tl.to('.video-banner--7 .video',{
      scale: .9
    }, "+=0.2")
  }

  

  return tl;
}


function partner(){

  let scroll = height * 6

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.video',
      scroller: '#wrapper',
      start: "top: 0",
      end: '+='+scroll,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });



  if(isMobile){

    tl.to('.video',{
      clipPath:  'circle(100vh at 50vw 50vh)'
    });

  }else{
    tl.to('.video',{
      clipPath:  'circle(100vw at 50vw 50vh)'
    });
  }

  return tl;
}

function partnerTitle(){


  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.lp-hero__slide--1',
      scroller: '#wrapper',
      start: "top: 0",
      end: '+='+height,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
    
  });

  tl.to('.lp-hero__slide--1',{
    opacity: 0, 
    delay: .5,
    ease: "power1.easeIn",
  },"-=1.01");


  return tl;
}


function partnerInfo(){
  var tl = "";

  gsap.utils.toArray(".lp-hero__slide--fade").forEach(box => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: box,
        scroller: '#wrapper',
        start: "top 10%",
        scrub: 1,
      }
    });
    
    tl.to(box,{
      opacity: 0,
      delay: 0.1,
      ease: "power4.easeOut",
    });
  
  });
  tl.to('.video',{
    scale: .9
  }, "-=0.1")

  return tl;
}


jQuery(function ($) {

  const master = gsap.timeline();

    if($('.intro').length){ master.add(intro); } 
    if($('.home').length){


        master.add(video1)
        master.add(video2)
        
        master.add(video3);
        master.add(video3Info);
        
        master.add(video4)

        master.add(video5);
        master.add(video5Info);

        master.add(video6);
        master.add(video6Info);

        master.add(video7);  
      
      }

    if($('.page-template-page-become-a-partner').length){
      master.add(partner);
      master.add(partnerTitle);
      master.add(partnerInfo);
    }
   





    $("#up-btn").on("click", function () {
      const target = document.querySelector('#wrapper');
      locoScroll.scrollTo(target);
    });
    
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this).attr('href');
            target = target.replace(/^\//, '');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              locoScroll.scrollTo(target);
            }
        }
    })

    $(window).resize(function() {
      ScrollTrigger.refresh();
    })

});

